interface IProps {
  width?: number;
  height?: number;
}

export default function Location18({ width, height }: IProps) {
  return (
    <img
      className="timeline-layout--svg--icon"
      src="https://media.synctrack.io/megamind-estimated/icon-timeline/location18.gif"
      width={width || 30}
      height={height || 30}
      alt="location icon"
    />
  );
}
